define(
({
  "load_error": "Ошибка загрузки",
  "description": "Запрос завершен некорректно. Убедитесь, что заказ был сохранен, и обновите эту страницу."
})
);
